<!-- Chat title template -->
<template>
  <div class="mt-4">
    <hr />

    <!-- Chat title -->
    <h2>Чат с Cooksy AI <i class="bi bi-openai text-warning"></i></h2>

    <!-- Chat description -->
    <div class="text-secondary small mt-n2 mb-4">
      AI подберет рецепты по вашему вкусу.
    </div>

    <!-- Chat image -->
    <div class="image-container">
      <img
        :src="randomImageUrl || getRandomImage()"
        class="image-chat"
        alt="Cooksy AI"
        @click="randomImageUrl = getRandomImage()"
      />
    </div>

    <!-- Chat text -->
    <div class="mt-3 mb-3">
      Coosy AI подберет рецепты по вашему вкусу. Ответит на все вопросы о
      рецептах, приготовлении еды. Поможет составить собственные рецепты. И
      многое другое! Для начала общения нажмите на кнопку ниже и в окне чата
      напишите свой вопрос или просто "Привет".
    </div>

    <ChatRecipe
      chatType="suggestions"
      title="Что приготовить?"
      placeholder="Спросите про рецепты..."
      @fullscreen-toggled="
        isChatFullscreenActive = $event;
        $emit('chatFullscreenActive', $event);
      "
      ref="chatRecipeComponent"
    />
    <div class="text-secondary small mt-n2 mb-4">
      AI подберет рецепты по вашему вкусу.
    </div>
  </div>
</template>

<script>
import ChatRecipe from "./ChatRecipe.vue";

export default {
  name: "ChatRecipeTitle",

  components: { ChatRecipe },

  data() {
    return {
      isChatFullscreenActive: false,
      randomImageUrl: "",
      images: [
        "Чат с cooksy - 1",
        "Чат с cooksy - 2",
        "Чат с cooksy - 3",
        "Чат с cooksy - 4",
        "Чат с cooksy - 5",
        // "Чат с cooksy - 6",
        "Чат с cooksy - 7",
        "Чат с cooksy - 8",
      ],
    };
  },

  methods: {
    getRandomImage() {
      let randomImage;
      do {
        const randomIndex = Math.floor(Math.random() * this.images.length);
        randomImage =
          this.$globalState.apiUrl + "/image.get/" + this.images[randomIndex];
      } while (this.randomImageUrl === randomImage);
      return randomImage;
    },
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}

.image-chat {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;

  /* Animation from RecipeView */
  transition: transform 0.3s ease-in-out;
}

.image-chat:hover {
  /* Animation from RecipeView */
  transform: scale(1.03);
}
</style>
